import { AccessGrant, Door, Query, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';

export function getVisitorGroupsForTenantWithTypesDataForQuery(
  getVisitorGroupsForTenant: Array<VisitorGroup>
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return {
    getVisitorGroupsForTenant
  };
}

// GET_VISITOR_GROUPS_FOR_TENANT only selects id/name/externalRef/accessGrants/type/isQrCodeVisitInviterGroup
const visitorGroupFieldsToRemove: (keyof VisitorGroup)[] = [
  'allowedAccessGrants',
  'defaultAccessGrants',
  'isAdminGroup',
  'maxNumberOfMembers',
  'memberIds',
  'members',
  'scheduledAccessGrants',
  'tenantId'
];
// GET_VISITOR_GROUPS_FOR_TENANT only selects id/name/hardwareIdentifier/batteryWarningLevel on doors
const doorFieldsToRemove: (keyof Door)[] = [
  'locations',
  'locationIds',
  'officeMode',
  'supportsOssCards',
  'taReaderId',
  'type'
];
// GET_VISITOR_GROUPS_FOR_TENANT only selects id/doors on accessGrants
const accessGrantFieldsToRemove: (keyof AccessGrant)[] = [
  'accessSchedule',
  'doorIds',
  'isOfficeModeEnabled',
  'locations',
  'locationIds',
  'name',
  'tenantId'
];

export const mockedGetVisitorGroupsForTenantWithTypesDataForQuery = getVisitorGroupsForTenantWithTypesDataForQuery([
  removeFields(
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupId0',
      accessGrants: [
        removeFields(
          generateMockAccessGrant({
            id: 'mockedAccessGrantId0',
            doors: [removeFields(generateMockDoor({ id: 'mockedDoorId0' }), doorFieldsToRemove)]
          }),
          accessGrantFieldsToRemove
        )
      ]
    }),
    visitorGroupFieldsToRemove
  ),
  removeFields(
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupId1',
      accessGrants: [
        removeFields(
          generateMockAccessGrant({
            id: 'mockedAccessGrantId1',
            doors: [removeFields(generateMockDoor({ id: 'mockedDoorId1' }), doorFieldsToRemove)]
          }),
          accessGrantFieldsToRemove
        )
      ]
    }),
    visitorGroupFieldsToRemove
  )
]);

export const mockedGetVisitorGroupsForTenantWithTypesDataAdmin = getVisitorGroupsForTenantWithTypesDataForQuery([
  generateMockVisitorGroup({
    id: 'mockedIdInstallers',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdInstallers' })],
    name: 'installers',
    externalRef: 'mockedExternalRefInstallers',
    type: VisitorGroupType.Installers
  }),
  generateMockVisitorGroup({
    id: 'mockedIdCleaners',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdCleaners' })],
    name: 'cleaners',
    externalRef: 'mockedExternalRefCleaners',
    type: VisitorGroupType.CoContractors
  }),
  generateMockVisitorGroup({
    id: 'mockedIdCo-contractors',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdCo-contractors' })],
    name: 'co-contractors',
    externalRef: 'mockedExternalRefCo-contractors',
    type: VisitorGroupType.CoContractors
  }),
  generateMockVisitorGroup({
    id: 'mockedIdAdmins',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdAdmins' })],
    name: 'admins',
    type: VisitorGroupType.AzureAd,
    externalRef: 'mockedExternalRefAdmins'
  }),
  generateMockVisitorGroup({
    id: 'mockedIdEmployees',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdEmployees' })],
    name: 'employees',
    type: VisitorGroupType.AzureAd,
    externalRef: 'mockedExternalRefEmployees'
  }),
  generateMockVisitorGroup({
    id: 'mockedIdVisitor_group_1',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdVisitor_group_1' })],
    name: 'visitor_group_1',
    type: VisitorGroupType.AzureAd,
    externalRef: 'mockedExternalRefVisitor_group_1'
  }),
  generateMockVisitorGroup({
    id: 'mockedIdVisitor_group_2',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdVisitor_group_2' })],
    name: 'visitor_group_2',
    type: VisitorGroupType.AzureAd,
    externalRef: 'mockedExternalRefVisitor_group_2'
  }),
  generateMockVisitorGroup({
    id: 'mockedIdVisitor_group_3',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdVisitor_group_3' })],
    name: 'visitor_group_3',
    type: VisitorGroupType.AzureAd,
    externalRef: 'mockedExternalRefVisitor_group_3'
  }),
  generateMockVisitorGroup({
    id: 'mockedIdVisitors',
    accessGrants: [generateMockAccessGrant({ doors: [], id: 'mockedAccessGrantIdVisitors' })],
    name: 'visitors',
    type: VisitorGroupType.ExternalVisitors,
    externalRef: 'mockedExternalRefVisitors'
  })
]);
